import { render, staticRenderFns } from "./notRole.vue?vue&type=template&id=6a104c38&scoped=true"
import script from "./notRole.vue?vue&type=script&lang=js"
export * from "./notRole.vue?vue&type=script&lang=js"
import style0 from "./notRole.vue?vue&type=style&index=0&id=6a104c38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a104c38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a104c38')) {
      api.createRecord('6a104c38', component.options)
    } else {
      api.reload('6a104c38', component.options)
    }
    module.hot.accept("./notRole.vue?vue&type=template&id=6a104c38&scoped=true", function () {
      api.rerender('6a104c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/notRole.vue"
export default component.exports